import React from 'react';
import { isEmpty, isNumber, isNumeric } from 'util/utils';
import classNames from "util/classNames";

const InputNumber = React.memo(function InputNumber({
	label,
	required,
	error,
	onChange,
	onBlur,
	onAdd,
	className,
	onRemove,
	min,
	max,
	...props
}) {
	const handleChange = React.useCallback(
		(event, castToNumber) => {
			event.preventDefault();
			const value = event?.target?.value;
			event.target.value = "";

			if (!isNumeric(value)) return; // return if not numeric fragment
			const number = Number(value); // cast to number
			const valueIsNumber = isNumber(number);

			if (!isEmpty(value) && valueIsNumber) {
				// check limits if not empty and type is number
				if ((isNumber(min) && number < min) || (isNumber(max) && number > max)) return;
			}

			if (castToNumber) {
				return onChange(valueIsNumber && !isEmpty(value) ? number : null);
			}

			onChange(value);
		},
		[onChange, min, max],
	);

	const handleBlur = React.useCallback(
		(event) => {
			handleChange(event, true); // cast to number on blur
			onBlur && onBlur(event);
		},
		[handleChange, onBlur],
	);

	const value = React.useMemo(() => (isEmpty(props?.value) ? "" : props?.value), [props?.value]);

	return (
		<div className={`from-group inputBlock ${className}`}>
			<label>
				{label} {required && <span className="required-ast">*</span>}
			</label>
			<div className={classNames(["inputWrapper", error && "error-message", props?.className])}>
				<input {...props} value={value} onChange={handleChange} onBlur={handleBlur} />
				{error && <div className="error">{error}</div>}
			</div>
		</div>
	);
});

export default InputNumber;